export default __webpack_public_path__ + "static/media/harvel-logo-blue.c35ed8dd.png";